<template>
  <div class="culture">
    <div class="banner"></div>
    <div class="culturecontent">
      <div class="navs">
        <navlist
          :navlist="navlist"
          @returnpath="returnpath"
          :navindex="navindex"
        />
      </div>
      <div class="miancontent">
        <productbuild
          v-if="navindex > -1"
          :datalist="
            navlist.list[navindex].children &&
            navlist.list[navindex].children.length > 0
              ? navlist.list[navindex].children
              : navlist.list[navindex].content
          "
          :type="
            navlist.list[navindex].children &&
            navlist.list[navindex].children.length > 0
              ? 1
              : 0
          "
          :navindex="navindex"
          :tablelist="tablelist"
          @changelast="changelast"
        />
      </div>
    </div>
  </div>
</template>

<script>
import navlist from "./commonnavs.vue";
import productbuild from "./productbuild.vue";
export default {
  components: {
    navlist,
    productbuild,
  },
  data() {
    return {
      navlist: {
        name: "产品系列",
        list: [
          {
            name: "施工总承包",
            index: 0,
            children: [
              {
                name: "铁路站房",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case1.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "调度所及铁路配套工程",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "机场",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "文化场馆",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "体育场馆",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "学校",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "地产住宅",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "医疗养老",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "政府办公",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "城市综合体",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "科研基地和研发中心",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
            ],
          },
          {
            name: "工程总承包",
            index: 1,
            children: [],
            content: [
              { name: "雄安站", icon: require("../assets/image/case8.png") },
              { name: "雄安站", icon: require("../assets/image/case2.png") },
              { name: "雄安站", icon: require("../assets/image/case3.png") },
              { name: "雄安站", icon: require("../assets/image/case4.png") },
              { name: "雄安站", icon: require("../assets/image/case5.png") },
              { name: "雄安站", icon: require("../assets/image/case6.png") },
              { name: "雄安站", icon: require("../assets/image/case7.png") },
              { name: "雄安站", icon: require("../assets/image/case8.png") },
            ],
          },
          {
            name: "基础设施",
            index: 2,
            children: [
              {
                name: "铁路交通",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "轨道交通",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
            ],
          },
          {
            name: "建筑工业化",
            index: 3,
            children: [],
            content: [
              { name: "雄安站", icon: require("../assets/image/case8.png") },
              { name: "雄安站", icon: require("../assets/image/case2.png") },
              { name: "雄安站", icon: require("../assets/image/case3.png") },
              { name: "雄安站", icon: require("../assets/image/case4.png") },
              { name: "雄安站", icon: require("../assets/image/case5.png") },
              { name: "雄安站", icon: require("../assets/image/case6.png") },
              { name: "雄安站", icon: require("../assets/image/case7.png") },
              { name: "雄安站", icon: require("../assets/image/case8.png") },
            ],
          },
          {
            name: "专业领域",
            index: 4,
            children: [
              {
                name: "装饰",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "安装",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "绿色产业",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "科技创新",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
              {
                name: "机械",
                content: [
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case2.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case3.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case4.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case5.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case6.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case7.png"),
                  },
                  {
                    name: "雄安站",
                    icon: require("../assets/image/case8.png"),
                  },
                ],
              },
            ],
          },
        ],
      },
      navindex: -1,
      navname: "",
      tablelist: [],
    };
  },
  mounted() {
    this.navindex = 0;
    this.returnpath(0);
  },
  watch: {
    $route(to, from) {
      if (to.query.index) {
        this.navindex = to.query.index;
      }
    },
  },
  methods: {
    changelast(e) {
      let arr = [];
      arr = this.navname.split("/");
      arr.pop();
      arr.push(e);
      this.navname = arr.join("/");
      this.getlist()
    },
    async getlist() {
      let data = {
        category: this.navname,
      };
      const res = await this.$http.plist(data);
      if (res.code == 200) {
        this.tablelist = res.data;
      } else {
        // 处理错误情况
        console.log("Error fetching news list:", res.data.msg);
      }
    },
    returnpath(e) {
      this.navindex = e;
      for (let i in this.navlist.list) {
        if (e == this.navlist.list[i].index) {
          if (e % 2 === 0) {
            this.navname = `产品系列/${this.navlist.list[i].name}/${this.navlist.list[i].children[0].name}`;

            this.getlist();
          } else {
            this.navname = `产品系列/${this.navlist.list[i].name}`;

            this.getlist();
          }
        }
      }
    },
  },
};
</script>

<style scoped lang="less">
.culture {
  .culturecontent {
    .miancontent {
      background: #fff;
      flex: 1;
      max-width: 100%;
      overflow: hidden;
    }
    .navs {
      width: 10.42vw;
      height: 21.88vw;
      margin-right: 1.25vw;
    }
    width: 100%;
    padding: 3.13vw 13.54vw;
    display: flex;
  }
  .banner {
    width: 100%;
    height: 26.04vw;
    //background: url("https://crec-website-1321777854.cos.ap-chengdu.myqcloud.com/news-picture/banner/bannerproducttop.png") no-repeat;
    background: url("https://ygs-official-website-prod.oss-cn-shanghai.aliyuncs.com/web-pic-bed/bannerproducttop.png") no-repeat;
    background-position: 0 0;
    background-size: 100% 100%;
  }
  width: 100%;
  background: rgba(240, 242, 246, 1);
}
::v-deep .el-tabs__nav-wrap::after {
  width: 0;
}
::v-deep .el-tabs__item {
  font-size: 0.83vw;
}
::v-deep .el-tabs__item.is-active {
  font-size: 0.94vw;
  color: #1961ac;
}
::v-deep .el-tabs__header {
  padding: 0 1.56vw;
}
::v-deep .el-tabs__active-bar {
  background-color: #1961ac;
}
</style>
